import { all, fork } from 'redux-saga/effects'
// main
// @PLOP-IMPORTS

export default function* rootSaga() {}
